import { laptopMediumMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';

const OPTIONS_BREAKPOINT = 'max-width: 820px';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  z-index: 2;
`;

export const Content = styled.div<{ showOptions: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 2px;
  position: absolute;
  top: -71px;
  left: 30px;

  @media (${laptopMediumMax}) {
    left: 15px;
  }

  @media (${mobileXXLargeMax}) {
    top: -57px;
  }

  ${(props) =>
    props.showOptions &&
    css`
      @media (${OPTIONS_BREAKPOINT}) {
        display: none;
      }
    `}
`;

export const Text = styled.p`
  font-size: 15px;
  font-weight: bold;
  color: ${(props) => props.theme.white};
  margin-left: 10px;
  white-space: nowrap;
`;

export const LinkButton = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  background-color: rgba(53, 53, 53, 0.5);
  transition: background-color linear 150ms;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:hover {
    background-color: rgba(53, 53, 53, 1);
  }

  // prevents custom new dev styles overwriting the svg color
  svg {
    color: ${({ theme }) => theme.white};
    font-size: 18px !important;
  }

  &.gallery-icon svg {
    width: 22px;
  }

  @media (${mobileXXLargeMax}) {
    &:not(:first-child) ${Text} {
      display: none;
    }
  }
`;

export const Options = styled.div<{ showOptions: boolean }>`
  position: relative;
  display: none;
  padding: 0 30px 10px;

  @media (${tabletMax}) {
    padding: 0 10px 10px;
  }

  ${(props) =>
    props.showOptions &&
    css`
      @media (${OPTIONS_BREAKPOINT}) {
        display: flex;
      }
    `}
`;

export const DropdownButton = styled.button`
  width: calc(100% - 130px);
  max-width: 360px;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: -73px;
  left: 30px;
  background-color: ${({ theme }) => theme.background};
  border-radius: 45px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  background-color: rgba(53, 53, 53, 0.5);
  transition: background-color linear 150ms;
  color: ${(props) => props.theme.white};

  svg {
    color: ${({ theme }) => theme.white};
  }

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  @media (${tabletMax}) {
    left: 10px;
    top: -63px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  padding-top: 10px;
  background: ${({ theme }) => theme.background};
  border-radius: 5px;

  svg path {
    fill: ${({ theme }) => theme.textDark};
  }
`;

export const IconLink = styled(Link)`
  display: block;
  margin: 0 12px;

  &.gallery-icon {
    width: 30px;
  }
`;
